import { useQueryClient } from 'react-query';
import { queryKeys } from '../fax-queries';

export const useInvalidateFaxContacts = () => {
  const queryClient = useQueryClient();
  return () => {
    const keys = [...queryKeys.base, 'list', 'contacts'];
    queryClient.invalidateQueries(keys);
  };
};
